import { render, staticRenderFns } from "./SelectSyncApp.vue?vue&type=template&id=54b6547e&scoped=true"
import script from "./SelectSyncApp.vue?vue&type=script&lang=js"
export * from "./SelectSyncApp.vue?vue&type=script&lang=js"
import style0 from "./SelectSyncApp.vue?vue&type=style&index=0&id=54b6547e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54b6547e",
  null
  
)

export default component.exports